<template>
    <!--begin::Menu-->
    <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px" data-kt-menu="true">
        <!--begin::Menu item-->
        <div class="menu-item px-3">
            <div class="menu-content d-flex align-items-center px-3">
                <!--begin::Avatar-->
                <div class="symbol symbol-50px me-5">
                    <img alt="Logo" src="/media/avatars/blank.png"/>
                </div>
                <!--end::Avatar-->

                <!--begin::Username-->
                <div class="d-flex flex-column">
                    <div class="fw-bolder d-flex align-items-center fs-5">
                        {{ $root.currentUser.firstname + ' ' + $root.currentUser.lastname }}
                        <span class="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2">{{ $root.currentUser.group ? $root.currentUser.group.name : '' }}</span>
                    </div>
                    <a :href="'mailto:'+ $root.currentUser.email" class="fw-bold text-muted text-hover-primary fs-7">{{ $root.currentUser.email }}</a>
                </div>
                <!--end::Username-->
            </div>

            <div class="px-3 pt-2 pb-3">
                <el-select v-model="selectedCompany" :placeholder="$t('menu.chooseCompanySelect')" filterable placement="bottom-end">
                    <el-option v-for="item in companies" :key="item.id" :value="item.id" :label="item.name"/>
                </el-select>
            </div>
        </div>
        <!--end::Menu item-->

        <!--begin::Menu separator-->
        <div class="separator my-2"></div>
        <!--end::Menu separator-->

        <!--begin::Menu item-->
        <!--<div class="menu-item px-5">
            <router-link to="/profile/overview" class="menu-link px-5">
                My Profile
            </router-link>
        </div>-->
        <!--end::Menu item-->

        <!--begin::Menu item-->
        <!--<div class="menu-item px-5">
           <router-link to="/profile/overview" class="menu-link px-5">
               <span class="menu-text">My Projects</span>
               <span class="menu-badge">
                   <span class="badge badge-light-danger badge-circle fw-bolder fs-7">3</span>
               </span>
           </router-link>
       </div>-->
        <!--end::Menu item-->

        <!--begin::Menu item-->
        <!--<div class="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start" data-kt-menu-flip="center, top">
            <router-link to="/profile/overview" class="menu-link px-5">
                <span class="menu-title">My Subscription</span>
                <span class="menu-arrow"></span>
            </router-link>

            <div class="menu-sub menu-sub-dropdown w-175px py-4">
                <div class="menu-item px-3">
                    <router-link to="/profile/overview" class="menu-link px-5">
                        Referrals
                    </router-link>
                </div>
                <div class="menu-item px-3">
                    <router-link to="/profile/overview" class="menu-link px-5">
                        Billing
                    </router-link>
                </div>
                <div class="menu-item px-3">
                    <router-link to="/profile/overview" class="menu-link px-5">
                        Payments
                    </router-link>
                </div>

                <div class="menu-item px-3">
                    <router-link to="/profile/overview" class="menu-link d-flex flex-stack px-5">
                        Statements

                        <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" title="View your statements"></i>
                    </router-link>
                </div>

                <div class="separator my-2"></div>

                <div class="menu-item px-3">
                    <div class="menu-content px-3">
                        <label class="form-check form-switch form-check-custom form-check-solid">
                            <input class="form-check-input w-30px h-20px" type="checkbox" value="1" checked="checked" name="notifications"/>
                            <span class="form-check-label text-muted fs-7">
                                Notifications
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>-->
        <!--end::Menu item-->

        <!--begin::Menu item-->
        <!--<div class="menu-item px-5">
            <router-link to="/profile/overview" class="menu-link px-5">
                My Statements
            </router-link>
        </div>-->
        <!--end::Menu item-->

        <!--begin::Menu separator-->
        <!--<div class="separator my-2"></div>-->
        <!--end::Menu separator-->

        <!--begin::Menu item-->
        <div class="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start" data-kt-menu-flip="center, top">
            <router-link to="#" class="menu-link px-5">
                <span class="menu-title position-relative">
                    {{ $t('userMenu.language') }}
                    <span class="fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0">
                        {{ currentLanguageLocale.name }}
                        <img class="w-15px h-15px rounded-1 ms-2" :src="currentLanguageLocale.flag" alt="metronic"/>
                    </span>
                </span>
            </router-link>

            <div class="menu-sub menu-sub-dropdown w-175px py-4">
                <div class="menu-item px-3">
                    <a @click="setLang('tr')" href="#" class="menu-link d-flex px-5" :class="{ active: currentLanguage('tr') }">
                        <span class="symbol symbol-20px me-4">
                            <img class="rounded-1" src="/media/flags/turkey.svg" alt="metronic"/>
                        </span>
                        Türkçe
                    </a>
                </div>

                <!-- <div class="menu-item px-3">
                    <a @click="setLang('es')" href="#" class="menu-link d-flex px-5" :class="{ active: currentLanguage('es') }">
                        <span class="symbol symbol-20px me-4">
                            <img class="rounded-1" src="/media/flags/spain.svg" alt="metronic"/>
                        </span>
                        Spanish
                    </a>
                </div>-->
            </div>
        </div>

        <div class="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start" data-kt-menu-flip="center, top">
            <a class="menu-link px-5">
                <span class="menu-title position-relative">
                    {{ $t('userMenu.theme.title') }}
                    <span class="fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0">
                        <i class="bi fs-9 me-2" :class="currentTheme.icon"></i>
                        {{ currentTheme.name }}
                    </span>
                </span>
            </a>

            <div class="menu-sub menu-sub-dropdown w-175px py-4">
                <div class="menu-item px-3">
                    <a href="#" @click.prevent="setTheme('light')" class="menu-link d-flex px-5" :class="{ active: theme === 'light' }">
                        <i class="bi bi-brightness-high-fill fs-5 me-2"></i>
                        {{ $t('userMenu.theme.light') }}
                    </a>
                </div>

                <div class="menu-item px-3">
                    <a href="#" @click.prevent="setTheme('dark')" class="menu-link d-flex px-5" :class="{ active: theme === 'dark' }">
                        <i class="bi bi-moon-stars-fill fs-5 me-2"></i>
                        {{ $t('userMenu.theme.dark') }}
                    </a>
                </div>

                <div class="menu-item px-3">
                    <a href="#" @click.prevent="setTheme('system')" class="menu-link d-flex px-5" :class="{ active: theme === 'system' }">
                        <i class="bi bi-circle-half fs-5 me-2"></i>
                        {{ $t('userMenu.theme.system') }}
                    </a>
                </div>
            </div>
        </div>

        <div v-if="hasMultipleVariants" class="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start" data-kt-menu-flip="center, top">
            <a class="menu-link px-5">
                <span class="menu-title position-relative">
                    {{ $t('userMenu.theme.themeStyle') }}
                    <span class="fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0">
                        <i class="bi fs-9 me-2" :class="activeVariant.icon"></i>
                        {{ activeVariant.name }}
                    </span>
                </span>
            </a>

            <div class="menu-sub menu-sub-dropdown w-175px py-4">
                <div class="menu-item px-3" v-for="(variant, key) in availableVariants" :key="key">
                    <a href="#" @click.prevent="setVariant(key)" class="menu-link d-flex px-5" :class="{ active: themeVariant[resolvedMode] === key }">
                        <i class="bi fs-5 me-2" :class="variant.icon"></i>
                        {{ variant.name }}
                    </a>
                </div>
            </div>
        </div>

        <div class="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start" data-kt-menu-flip="center, top">
            <a class="menu-link px-5">
                <span class="menu-title position-relative">
                    {{ $t('userMenu.layout.content.title') }}
                    <span class="fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0">
                        <i class="bi transform-rotate-90deg fs-9 me-2" :class="currentLayoutContentFluid.icon"></i>
                        {{ currentLayoutContentFluid.name }}
                    </span>
                </span>
            </a>

            <div class="menu-sub menu-sub-dropdown w-175px py-4">
                <div class="menu-item px-3">
                    <a href="#" @click.prevent="setLayoutContent('default')" class="menu-link d-flex px-5" :class="{ active: layoutContentFluid === 'default' }">
                        <i class="bi bi-arrows-collapse transform-rotate-90deg fs-5 me-2"></i>
                        {{ $t('userMenu.layout.content.default') }}
                    </a>
                </div>

                <div class="menu-item px-3">
                    <a href="#" @click.prevent="setLayoutContent('fluid')" class="menu-link d-flex px-5" :class="{ active: layoutContentFluid === 'fluid' }">
                        <i class="bi bi-arrows-expand transform-rotate-90deg fs-5 me-2"></i>
                        {{ $t('userMenu.layout.content.fluid') }}
                    </a>
                </div>
            </div>
        </div>

        <div class="separator my-2"></div>

        <div v-if="$route.path === '/dashboard'" class="menu-item px-5">
            <a class="menu-link px-5 d-flex align-items-center" @click="onDashboardCustomize">
                <i class="bi bi-grid-1x2 fs-5 me-3"></i>
                {{ $t('common.dashboard.customizeMenu') }}
            </a>
        </div>

        <div v-if="$route.path === '/dashboard'" class="separator my-2"></div>

        <div class="menu-item px-5">
            <label class="menu-link px-5 form-check form-switch form-check-custom form-check-solid d-flex align-items-center mb-0" @click.stop>
                <input class="form-check-input w-30px h-20px" type="checkbox" :checked="syncMode === 'remote'" @change="toggleSyncMode"/>
                <span ref="syncLabel" class="form-check-label text-muted fs-7 ms-3 user-menu-marquee" :class="{ 'user-menu-marquee--active': marqueeReady }">
                    <span class="user-menu-marquee__text">{{ $t('userMenu.syncSettings') }}</span>
                </span>
            </label>
        </div>

        <div class="separator my-2"></div>

        <div class="menu-item px-5">
            <router-link to="/account/overview" class="menu-link px-5">
                {{ $t('userMenu.accountSettings') }}
            </router-link>
        </div>

        <div class="menu-item px-5">
            <a @click="signOut()" class="menu-link px-5"> {{ $t('userMenu.signOut') }} </a>
        </div>
    </div>
    <!--end::Menu-->
</template>

<script>
import {Actions} from "@/store/enum/StoreEnums";
import layoutConfig from "@/core/config/DefaultLayoutConfig.js";
import UserConfigService from "@/core/services/UserConfigService";
import dashboardService from "@/components/dashboard/dashboardService";

export default {
    name: "kt-user-menu",
    components: {},
    data() {
        return {
            syncMode: UserConfigService.getSyncMode(),
            marqueeReady: false,
            countries: {
                tr: {
                    flag: "/media/flags/turkey.svg",
                    name: "Türkçe",
                },
                en: {
                    flag: "/media/flags/united-states.svg",
                    name: "English",
                }
            },
            themes: {
                light: {
                    icon: 'bi-brightness-high-fill',
                    name: this.$t('userMenu.theme.lightSort')
                },
                dark: {
                    icon: 'bi-moon-stars-fill',
                    name: this.$t('userMenu.theme.darkSort')
                },
                system: {
                    icon: 'bi-circle-half',
                    name: this.$t('userMenu.theme.system')
                }
            },
            variantOptions: {
                light: {
                    default: { icon: 'bi-brightness-high-fill', name: this.$t('userMenu.theme.lightSort') },
                    cream: { icon: 'bi-cup-fill', name: this.$t('userMenu.theme.creamSort') }
                },
                dark: {
                    dark: { icon: 'bi-moon-stars-fill', name: this.$t('userMenu.theme.darkSort') },
                    midnight: { icon: 'bi-moon-fill', name: this.$t('userMenu.theme.midnightSort') }
                }
            },
            theme: 'system',
            resolvedMode: 'light',
            themeVariant: {
                light: localStorage.getItem('app_light_variant') || 'default',
                dark: localStorage.getItem('app_dark_variant') || 'dark',
            },
            layoutContents: {
                default: {
                    icon: 'bi-arrows-collapse',
                    name: this.$t('userMenu.layout.content.default')
                },
                fluid: {
                    icon: 'bi-arrows-expand',
                    name: this.$t('userMenu.layout.content.fluid')
                }
            },
        }
    },
    computed: {
        companies() {
            return this.$store.state.company.authorized.table.data
        },
        selectedCompany: {
            get() {
                return this.$store.state.company.authorized.selectCompany
            },
            set(value) {
                this.$store.dispatch('company/authorized/setSelectCompany', value)
            }
        },
        currentLanguageLocale() {
            return this.countries[this.$i18n.locale];
        },
        currentTheme() {
            return this.themes[this.theme]
        },
        activeVariant() {
            const mode = this.resolvedMode
            const key = this.themeVariant[mode]
            return this.variantOptions[mode]?.[key] || Object.values(this.variantOptions[mode])[0]
        },
        availableVariants() {
            return this.variantOptions[this.resolvedMode] || {}
        },
        hasMultipleVariants() {
            return Object.keys(this.availableVariants).length > 1
        },
        currentLayoutContentFluid() {
            return this.layoutContents[this.layoutContentFluid]
        },
        layoutContentFluid() {
            return layoutConfig.content.width;
        },
    },
    created() {

    },
    async mounted() {
        this.initTheme()
        this.initMarquee()

        this.$store.dispatch('company/authorized/initSelectCompany');

        await this.$store.dispatch('company/authorized/get', {
            page: {pageSize: 9999}
        })

        await this.$store.dispatch('company/module/get', {
            page: {pageSize: 9999}
        })
    },
    methods: {
        signOut() {
            this.$store.dispatch(Actions.LOGOUT).then(() => this.$router.push({path: "/login"}));
        },
        onDashboardCustomize() {
            dashboardService.openCustomize();
        },
        setLang(lang) {
            localStorage.setItem("lang", lang);
            this.$i18n.locale = lang;
        },
        initTheme() {
            let saved = localStorage.getItem('app_theme') || 'system'

            if (saved === 'midnight') {
                saved = 'dark'
                localStorage.setItem('app_theme', 'dark')
                localStorage.setItem('app_dark_variant', 'midnight')
                this.themeVariant.dark = 'midnight'
            }

            if (this.themeVariant.light === 'indigo' || this.themeVariant.light === 'emerald') {
                this.themeVariant.light = 'default'
                localStorage.setItem('app_light_variant', 'default')
            }

            if (this.themeVariant.dark === 'neon') {
                this.themeVariant.dark = 'dark'
                localStorage.setItem('app_dark_variant', 'dark')
            }

            this.theme = saved
            this.applyTheme(saved)

            window.matchMedia('(prefers-color-scheme: dark)')
                .addEventListener('change', () => {
                    if (this.theme === 'system') {
                        this.applyTheme('system')
                    }
                })
        },
        setTheme(mode) {
            this.theme = mode
            localStorage.setItem('app_theme', mode)
            this.applyTheme(mode)
        },
        applyTheme(mode) {
            let resolved = mode

            if (mode === 'system') {
                resolved = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
            }

            this.resolvedMode = resolved

            const html = document.documentElement
            const variant = this.themeVariant[resolved]

            const variantClasses = ['dark', 'light']
            for (const m in this.variantOptions) {
                for (const k in this.variantOptions[m]) {
                    if (k !== 'default' && !variantClasses.includes(k)) variantClasses.push(k)
                }
            }
            html.classList.remove(...variantClasses)
            html.setAttribute('data-bs-theme', resolved)
            html.classList.add(resolved)

            if (variant && variant !== resolved && variant !== 'default') {
                html.setAttribute('data-theme', variant)
                html.classList.add(variant)
            } else {
                html.setAttribute('data-theme', resolved)
            }
        },
        setVariant(key) {
            const mode = this.resolvedMode
            this.themeVariant[mode] = key
            localStorage.setItem('app_' + mode + '_variant', key)
            this.applyTheme(this.theme)
        },
        currentLanguage(lang) {
            return this.$i18n.locale === lang;
        },
        setLayoutContent(mode) {
            layoutConfig.content.width = mode;
            localStorage.setItem("contentWidth", mode);
        },
        toggleSyncMode() {
            this.syncMode = this.syncMode === 'remote' ? 'local' : 'remote'
            UserConfigService.setSyncMode(this.syncMode)
        },
        initMarquee() {
            const container = this.$refs.syncLabel
            if (!container) return
            this._marqueeRO = new ResizeObserver(() => {
                const textEl = container.firstElementChild
                if (!textEl || container.clientWidth === 0) return
                const overflow = textEl.scrollWidth - container.clientWidth
                if (overflow > 0) {
                    container.style.setProperty('--marquee-distance', `-${overflow}px`)
                    this.marqueeReady = true
                }
            })
            this._marqueeRO.observe(container)
        },
    },
    beforeUnmount() {
        if (this._marqueeRO) this._marqueeRO.disconnect()
    },
};
</script>

<style scoped>
.user-menu-marquee {
    overflow: hidden;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
}
.user-menu-marquee__text {
    display: inline-block;
}
.user-menu-marquee--active .user-menu-marquee__text {
    animation: user-menu-marquee 6s ease-in-out infinite;
}
@keyframes user-menu-marquee {
    0%, 20% { transform: translateX(0); }
    35%, 55% { transform: translateX(var(--marquee-distance)); }
    70%, 100% { transform: translateX(0); }
}
</style>